module.exports = __webpack_public_path__ + "static/media/lupin.8df8cc2e.svg";